var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { FileUploadButton, ImageDropzone } from 'react-file-utils';
import { EmojiPicker } from './EmojiPicker';
import { useMessageInput } from './hooks/messageInput';
import { EmojiIconSmall as DefaultEmojiIcon, FileUploadIcon as DefaultFileUploadIcon, } from './icons';
import { UploadsPreview } from './UploadsPreview';
import { KEY_CODES } from '../AutoCompleteTextarea/listener';
import { ChatAutoComplete } from '../ChatAutoComplete/ChatAutoComplete';
import { Tooltip } from '../Tooltip/Tooltip';
import { useChannelContext } from '../../context/ChannelContext';
import { useTranslationContext } from '../../context/TranslationContext';
export var EditMessageForm = function (props) {
    var _a = props.additionalTextareaProps, additionalTextareaProps = _a === void 0 ? {} : _a, clearEditingState = props.clearEditingState, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.EmojiIcon, EmojiIcon = _c === void 0 ? DefaultEmojiIcon : _c, _d = props.FileUploadIcon, FileUploadIcon = _d === void 0 ? DefaultFileUploadIcon : _d, _e = props.focus, focus = _e === void 0 ? false : _e, _f = props.grow, grow = _f === void 0 ? true : _f, _g = props.maxRows, maxRows = _g === void 0 ? 10 : _g, mentionAllAppUsers = props.mentionAllAppUsers, mentionQueryParams = props.mentionQueryParams, _h = props.publishTypingEvent, publishTypingEvent = _h === void 0 ? true : _h;
    var channelContext = useChannelContext();
    var t = useTranslationContext().t;
    var messageInput = useMessageInput(__assign(__assign({}, props), { additionalTextareaProps: additionalTextareaProps,
        disabled: disabled,
        focus: focus,
        grow: grow,
        maxRows: maxRows,
        publishTypingEvent: publishTypingEvent }));
    useEffect(function () {
        var onKeyDown = function (event) {
            if (event.keyCode === KEY_CODES.ESC && clearEditingState)
                clearEditingState();
        };
        document.addEventListener('keydown', onKeyDown);
        return function () { return document.removeEventListener('keydown', onKeyDown); };
    }, [clearEditingState]);
    return (React.createElement("div", { className: 'str-chat__edit-message-form' },
        React.createElement(ImageDropzone, { accept: channelContext.acceptedFiles, disabled: !messageInput.isUploadEnabled || messageInput.maxFilesLeft === 0, handleFiles: messageInput.uploadNewFiles, maxNumberOfFiles: messageInput.maxFilesLeft, multiple: channelContext.multipleUploads },
            React.createElement("form", { onSubmit: messageInput.handleSubmit },
                messageInput.isUploadEnabled && React.createElement(UploadsPreview, __assign({}, messageInput)),
                React.createElement(EmojiPicker, __assign({}, messageInput, { small: true })),
                React.createElement(ChatAutoComplete, { additionalTextareaProps: additionalTextareaProps, commands: messageInput.getCommands(), grow: grow, handleSubmit: messageInput.handleSubmit, innerRef: messageInput.textareaRef, maxRows: maxRows, mentionAllAppUsers: mentionAllAppUsers, mentionQueryParams: mentionQueryParams, onChange: messageInput.handleChange, onPaste: messageInput.onPaste, onSelectItem: messageInput.onSelectItem, placeholder: t('Type your message'), rows: 1, value: messageInput.text }),
                React.createElement("div", { className: 'str-chat__message-team-form-footer' },
                    React.createElement("div", { className: 'str-chat__edit-message-form-options' },
                        React.createElement("span", { className: 'str-chat__input-emojiselect', onClick: messageInput.openEmojiPicker },
                            React.createElement(EmojiIcon, null)),
                        messageInput.isUploadEnabled && (React.createElement("div", { className: 'str-chat__fileupload-wrapper', "data-testid": 'fileinput' },
                            React.createElement(Tooltip, null, messageInput.maxFilesLeft
                                ? t('Attach files')
                                : t("You've reached the maximum number of files")),
                            React.createElement(FileUploadButton, { accepts: channelContext.acceptedFiles, disabled: messageInput.maxFilesLeft === 0, handleFiles: messageInput.uploadNewFiles, multiple: channelContext.multipleUploads },
                                React.createElement("span", { className: 'str-chat__input-fileupload' },
                                    React.createElement(FileUploadIcon, null)))))),
                    React.createElement("div", null,
                        React.createElement("button", { onClick: function () {
                                if (clearEditingState) {
                                    clearEditingState();
                                }
                            } }, t('Cancel')),
                        React.createElement("button", { type: 'submit' }, t('Send'))))))));
};
